module.exports = __webpack_public_path__ + "static/anima-gc-square-45b79d0dbd56afdde67db0efb228177c.png";